export default __webpack_public_path__ + "328b83d00e1371c7df7c31ce24897b98.svg";